import DefaultTheme from './default-theme';

const LightContrastBiggerTheme = {
	...DefaultTheme,

	code: 'light-contrast-bigger',
	// codeEditorTheme: 'light',

	fontColor: '#444444',
	fontSize: 14
};

export default LightContrastBiggerTheme;